import React from "react";
import { Outlet, Link, withRouter, useHistory } from "react-router-dom";
import CustomReportingBody from "../components/CustomReportingBody";
import Footer from "../components/Footer";
import Header from "../components/Header";

function CustomReporting() {
  return (
    <div>
      <Header />
      <CustomReportingBody />
      <Footer />
    </div>
  );
}
export default withRouter(CustomReporting);
